var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleFormCard',{ref:"formCreateSubAccount",attrs:{"formContent":_vm.formCreateSubAccount,"metadata":_vm.metadata,"metadataLoaded":_vm.metadataLoaded,"showCancelButton":false,"locali18n":_vm.$i18n},on:{"submitForm":_vm.CreateUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }